import styled from 'styled-components';

export const DatetimeLabel = styled.span`
    color: #8C8C8C;
    font-size: 12px
`;